import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 21.3 20.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11 14.8c0-.7.3-.8 1-.4 1.2.7 2.4 1.3 2.4 1.3 0-.4.4-.7 1.1-.5s1.4.3 1.4.3-.4-.9-.6-1.3c-.3-.7 0-1.1.3-1.2 0 0-.4-.3-.7-.5-.6-.4-.5-.9.1-1.1.8-.4 1.9-.8 1.9-.8-.3-.2-.7-.7-.3-1.4.4-.6 1.1-1.5 1.1-1.5h-1.9c-.7 0-.9-.6-.9-1 0 0-1.1.8-1.9 1.3-.7.5-1.3 0-1.2-.8.2-1.2.3-2.6.3-2.6-.4.4-1.1.3-1.5-.3-.5-1-1-2.2-1-2.2s-.5 1.2-1 2.2c-.3.6-1 .7-1.4.4 0 0 .1 1.4.3 2.6.1.7-.5 1.2-1.2.7-.8-.5-2-1.3-2-1.3 0 .4-.2.9-.9 1H2.5s.7.9 1.1 1.5c.4.6 0 1.2-.3 1.4 0 0 1 .5 1.9.8.6.3.8.7.1 1.1-.2.2-.7.5-.7.5.4.1.7.5.4 1.2-.2.4-.6 1.3-.6 1.3s.7-.2 1.4-.3c.7-.2 1 .2 1.1.5 0 0 1.2-.7 2.4-1.3.6-.4 1-.2 1 .4v1.7c0 1-.2 2-.5 2.6-4.5-.5-8.3-4.1-8.3-8.9s4.1-8.9 9.2-8.9 9.2 4 9.2 8.9c0 4.6-3.6 8.4-8.2 8.9v1.2c5.4-.5 9.6-4.8 9.6-10.1C21.3 4.5 16.5 0 10.6 0S0 4.5 0 10.1c0 4.9 3.7 9 8.6 9.9.8.2 1.3.3 1.8.8.5-1 .6-3 .6-4.1v-1.9Z",
      style: {"fill":"#f01428"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "AC-logo"}) } }